export default __webpack_public_path__ + "static/media/morning.51f8c471.svg";